<div class="shadow-sm p-3 mb-5 bg-white rounded" *ngIf="this.equipo">
    <button class="btn btn-sm btn-secondary" style="float: right" [routerLink]="['/equipo', equipo.id]">Ver más</button>
    <span class="alias">{{ equipo.alias }}</span><br>
    <span class="nombre">{{ equipo.nombre }}</span><br>
    <span class="border border-secondary rounded" style="background-color: {{ equipo.color }};">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;
    <span class="border border-secondary rounded" style="background-color: {{ equipo.colorAlternativo }};">&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span class="ubicacion">&nbsp;&nbsp;|&nbsp;{{ obtenerUbicacion(equipo.ubicacion.comuna).nombre }}</span>
</div>